// Auto-generated from EmailVisibilityEnum

export const emailVisibility = {
  management: 'management',
  projectPeers: 'projectPeers',
  domainMembers: 'domainMembers',
}

export type TEmailVisibility = (typeof emailVisibility)[keyof typeof emailVisibility];
